const statusLabel = {
  title: 'En proceso',
  title1: 'Vencido',
  title2: 'Cancelado',
  title3: 'Concluido',
};

export default statusLabel;
